export interface DataTransformer {
  serialize<T>(data: T): string;
  deserialize<T>(data: string): T;
}

export const JSONTransformer: DataTransformer = {
  serialize: (data) => JSON.stringify(data),
  deserialize: <T>(data: string) => JSON.parse(data) as T,
};
